import React from "react";
import PropTypes from "prop-types";
import { Box, FormHelperText, Typography } from "@mui/material";
import { clx } from "../../../utils/Helpers";

const UIFieldShell = ({
  id,
  label,
  optionalLabel,
  required,
  helperText,
  error,
  children,
  classNames,
  endLabelElement,
  counterText,
  counterAtLimit,
  ...props
}) => (
  <Box
    className={clx("ui-field", error ? "ui-field--error" : "", classNames.root)}
  >
    {label && (
      <div className="ui-field__header">
        <Typography
          className={clx(
            "ui-field__label",
            classNames.label,
            props?.classNames?.label,
          )}
          component="label"
          htmlFor={id}
        >
          {label}
          {required && <span className="ui-field__required">*</span>}
          {optionalLabel && (
            <span className="ui-field__optional">{optionalLabel}</span>
          )}
        </Typography>
        {endLabelElement && endLabelElement}
      </div>
    )}
    <Box className="ui-field__control">{children}</Box>
    {(helperText || counterText) && (
      <Box className="ui-field__footer">
        {helperText && (
          <FormHelperText
            error={error}
            className={clx(
              "ui-field__helper",
              { "ui-field__helper--error": error },
              classNames.helper,
            )}
          >
            {helperText}
          </FormHelperText>
        )}
        {counterText && (
          <span
            className={clx(
              "ui-field__counter",
              counterAtLimit && "ui-field__counter--limit",
            )}
          >
            {counterText}
          </span>
        )}
      </Box>
    )}
  </Box>
);

UIFieldShell.propTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  optionalLabel: PropTypes.node,
  required: PropTypes.bool,
  helperText: PropTypes.node,
  error: PropTypes.bool,
  children: PropTypes.node.isRequired,
  classNames: PropTypes.object,
  endLabelElement: PropTypes.node,
  counterText: PropTypes.node,
  counterAtLimit: PropTypes.bool,
};

UIFieldShell.defaultProps = {
  id: undefined,
  label: null,
  optionalLabel: null,
  required: false,
  helperText: null,
  error: false,
  classNames: {},
  endLabelElement: null,
  counterText: null,
  counterAtLimit: false,
};

export default UIFieldShell;
